import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import NoOrg from 'src/features/auth/components/NoOrg';

export const Route = createFileRoute('/_auth/no-org')({
  head: () => ({
    meta: [{ title: 'No Organization | Tekst' }],
  }),
  component: NoOrgPage,
});

function NoOrgPage() {
  function handleSupport() {
    window.location.href = 'https://support.tekst.com';
  }

  return (
    <AuthProvider>
      <NoOrg redirectUrl="/login" className="w-[450px] h-[300px]" handleSupport={handleSupport} />
    </AuthProvider>
  );
}
